import { render, staticRenderFns } from "./QuestionsSelect.vue?vue&type=template&id=10db2815&scoped=true&"
import script from "./QuestionsSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionsSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSelect.vue?vue&type=style&index=0&id=10db2815&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db2815",
  null
  
)

export default component.exports